import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import {
  type GetExploreImageV1ExploreImagesExploreImageIdGetData,
  type GetExploreImageV1ExploreImagesExploreImageIdGetError,
  type GetExploreImageV1ExploreImagesExploreImageIdGetResponse,
  getExploreImageV1ExploreImagesExploreImageIdGet,
} from '../../generated';

export type GetExploreImageQueryVariables = GetExploreImageV1ExploreImagesExploreImageIdGetData['path'];

export type GetExploreImageQuery = GetExploreImageV1ExploreImagesExploreImageIdGetResponse;

export const useGetExploreImageQuery = <
  TData = GetExploreImageQuery,
  TError = GetExploreImageV1ExploreImagesExploreImageIdGetError,
>(
  { explore_image_id }: GetExploreImageQueryVariables,
  options?: Omit<UseQueryOptions<GetExploreImageQuery, TError, TData>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery<GetExploreImageQuery, TError, TData>({
    queryKey: ['GetExploreImage', { explore_image_id }],
    queryFn: async () => {
      const { data } = await getExploreImageV1ExploreImagesExploreImageIdGet({
        path: { explore_image_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useGetExploreImageQuery.getKey = ({ explore_image_id }: GetExploreImageQueryVariables) => [
  'GetExploreImage',
  { explore_image_id },
];

useGetExploreImageQuery.fetcher = (
  { explore_image_id }: GetExploreImageQueryVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await getExploreImageV1ExploreImagesExploreImageIdGet({
      path: { explore_image_id },
      throwOnError: true,
    });
    return data;
  };
};
